import { post } from '../axios'

// 公共功能配置列表
export function commonConfig_list_post(map, option) {
  return post(
    `${process.env.VUE_APP_COMMONCONFIG}/commonConfig/list`,
    map,
    option
  ).then(response => response)
}

// 查询Popup详情
export function commonConfig_popup_detail_post(map, option) {
  return post(
    `${process.env.VUE_APP_COMMONCONFIG}/commonConfig/popup/detail`,
    map,
    option
  ).then(response => response)
}

// 查询Popup详情
export function commonConfig_popup_save_post(map, option) {
  return post(
    `${process.env.VUE_APP_COMMONCONFIG}/commonConfig/popup/save`,
    map,
    option
  ).then(response => response)
}

// 查询Topbar详情
export function commonConfig_topbar_detail_post(map, option) {
  return post(
    `${process.env.VUE_APP_COMMONCONFIG}/commonConfig/topbar/detail`,
    map,
    option
  ).then(response => response)
}

// 保存Topbar
export function commonConfig_topbar_save_post(map, option) {
  return post(
    `${process.env.VUE_APP_COMMONCONFIG}/commonConfig/topbar/save`,
    map,
    option
  ).then(response => response)
}

// 查询cookie详情
export function commonConfig_cookie_detail_post(map, option) {
  return post(
    `${process.env.VUE_APP_COMMONCONFIG}/commonConfig/cookie/detail`,
    map,
    option
  ).then(response => response)
}

// 保存cookie
export function commonConfig_cookie_save_post(map, option) {
  return post(
    `${process.env.VUE_APP_COMMONCONFIG}/commonConfig/cookie/save`,
    map,
    option
  ).then(response => response)
}

// 查询footer政策条详情
export function commonConfig_footerPolicy_detail_post(map, option) {
  return post(
    `${process.env.VUE_APP_COMMONCONFIG}/commonConfig/footerPolicy/detail`,
    map,
    option
  ).then(response => response)
}

// 保存footer政策条
export function commonConfig_footerPolicy_save_post(map, option) {
  return post(
    `${process.env.VUE_APP_COMMONCONFIG}/commonConfig/footerPolicy/save`,
    map,
    option
  ).then(response => response)
}

// 查询综合配置详情
export function commonConfig_integratedConfig_detail_post(map, option) {
  return post(
    `${process.env.VUE_APP_COMMONCONFIG}/commonConfig/integratedConfig/detail`,
    map,
    option
  ).then(response => response)
}

// 保存综合配置
export function commonConfig_integratedConfig_save_post(map, option) {
  return post(
    `${process.env.VUE_APP_COMMONCONFIG}/commonConfig/integratedConfig/save`,
    map,
    option
  ).then(response => response)
}

// 查询活动详情
export function commonConfig_activity_detail_post(map, option) {
  return post(
    `${process.env.VUE_APP_COMMONCONFIG}/commonConfig/activity/detail`,
    map,
    option
  ).then(response => response)
}

// 保存活动
export function commonConfig_activity_save_post(map, option) {
  return post(
    `${process.env.VUE_APP_COMMONCONFIG}/commonConfig/activity/save`,
    map,
    option
  ).then(response => response)
}
// 保存活动
export function commonConfig_page_enum_post(map, option) {
  return post(
    `${process.env.VUE_APP_COMMONCONFIG}/commonConfig/page/enum`,
    map,
    option
  ).then(response => response)
}
